import React from "react";
import css from "./styles.styl";

const FormField = ({ 
    label, 
    error, 
    children, 
    className = "",
    isLast = false 
}) => {
    const fieldClass = isLast ? css.lastFormField : css.formField;
    
    return (
        <div className={`${fieldClass} ${className}`}>
            <label className={css.formLabel}>
                {label}
            </label>
            {children}
            {error && (
                <div className={css.fieldError}>
                    {error}
                </div>
            )}
        </div>
    );
};

export default FormField;